import { LocalStorageKeys } from "@/constants";

export const getMerchantUpi = async () => {
  return await localStorage.getItem(LocalStorageKeys.MERCHANT_UPI);
};
